import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      {/* <div class="theme-element timer-element">
        <picture>
          <img
            src="../images/timer-left-element.svg"
            width="100%"
            alt="Raymond's MIG Bandra"
          />
        </picture>
      </div>
      <div class="theme-element timer-element-right">
        <picture>
          <img
            src="../images/timer-right-element.svg"
            width="100%"
            alt="Raymond's MIG Bandra"
          />
        </picture>
      </div> */}
      <div class="over1">
        <h1
          class="d-block section-heading color-primary text-capitalize"
          style={{ marginBottom: "1.25rem" }}
        >
          {project} - Project Overview
        </h1>
        <center>
          <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
            Experience Luxurious Living in Mumbai's Prime Locale
          </h3>
        </center>
        <p>
          Raymond Realty is redeveloping the iconic MIG VI CHS in Bandra East,
          Mumbai, introducing luxurious 3 & 4 BHK homes in one of Mumbai’s prime
          locations. This redevelopment offers a seamless blend of modern
          architecture, thoughtful design, and world-class amenities, catering
          to those seeking a comfortable and convenient lifestyle. With its
          commitment to quality and excellence, Raymond MIG Bandra promises a
          perfect living experience that balances sophistication with everyday
          functionality.
        </p>
        <p>
          Strategically located in Bandra East, known for its excellent
          connectivity and access to essential services, residents can easily
          reach malls, schools, hospitals, and major transport routes, making it
          a very convenient location for city living. At the same time, the area
          has green spaces that offer a peaceful and quiet atmosphere. This
          redevelopment by Raymond Realty is expected to offer good returns on
          investment as it combines modern conveniences with a high-quality
          living environment.
        </p>
        {/* <button id="toggle" class="btn btn-link btn-sm more">
          Read More
        </button> */}
      </div>

      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          Highlights of Raymond MIG Bandra
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>Spanning 2 acres in Bandra East</span>
              </li>
              <li>
                <span>Luxurious 3 & 4 BHK homes</span>
              </li>
              <li>
                <span>Modern architecture and thoughtful design</span>
              </li>
              {/* <li>
                <span>Ample Open Spaces</span>
              </li> */}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy">
              <li>
                <span>World-class amenities</span>
              </li>
              <li>
                <span>Excellent connectivity to essential services</span>
              </li>
              <li>
                <span>Peaceful and quiet atmosphere with green spaces</span>
              </li>
              {/* <li>
                <span>Premium Amenities</span>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={() => handleShowModal("Download Brochure")}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
